import { create } from 'zustand';

interface VoiceUiState {
  watchingUserId: string | null;
  setWatchingUserId: (id: string | null) => void;
  /**
   * Rooms currently on air, channelId → the epoch ms it started.
   *
   * Kept app-wide rather than in the room view: the event announcing it goes to
   * the whole guild, and somebody who opens the channel a minute after it went
   * live has to see the indicator too — they never received the event, so the
   * state has to have been remembered for them.
   */
  onAir: Record<string, number>;
  setOnAir: (channelId: string, since: number | null) => void;
  /** Replaces the whole map from the connection snapshot. A reconnect must
   *  also drop rooms that went off air while this client was offline. */
  resetOnAir: (onAir: Record<string, number>) => void;
}

export const useVoiceUiStore = create<VoiceUiState>((set) => ({
  watchingUserId: null,
  setWatchingUserId: (id) => set({ watchingUserId: id }),
  onAir: {},
  setOnAir: (channelId, since) =>
    set((state) => {
      if (since === null) {
        if (!(channelId in state.onAir)) return state;
        const next = { ...state.onAir };
        delete next[channelId];
        return { onAir: next };
      }
      if (state.onAir[channelId] === since) return state;
      return { onAir: { ...state.onAir, [channelId]: since } };
    }),
  resetOnAir: (onAir) => set({ onAir: { ...onAir } }),
}));
